<template>
    <div class="widget-item big-value-widget">
        <small class="widget-channel-info" v-if="this.widgetData.channel_name && !$parent.createMode">Channel : {{ this.widgetData.channel_name }}</small>
        <a v-if="!editDisabled && !widgetData.required && $parent.createMode" class="remove-widget" @click.prevent="$parent.removeWidget(this.widgetData.id);"><i class="fa fa-times"></i></a>
        <div class="widget-body">
            <div class="row">
                <div class="col-12">
                    <div class="title">{{this.widgetData.title}}</div>
                    <div class="value">{{this.widgetData.data.value}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import moment from 'moment';

    Vue.use(VueEvents)

    export default {
        name: 'widget-big-value',
        props: [
            'widgetData',
            'editDisabled',
        ],
        data() {
            return {
                alert: {
                    message: "",
                    status: "alert-success",
                    timeOut: 15000,
                },
                uiStates: {
                    showLoading: true,
                },
                loggedInPlanDetails: this.planDetails,
            }
        },
    };
</script>

<style scoped="" lang="scss">
    .big-value-widget{
        padding-top: 65px !important;
        padding-bottom: 60px !important;
        .value{
            font-size: 64px;
            color: #9D9B9B;
            text-align: center;
        }
        .title{
            font-size: 18px;
            color: #1F2529;
            text-align: center;
        }
    }
</style>
